import React from 'react';
import Icon from '../../../../../../../../generic-components/Icon';
import { threeDotsIcon } from '../../../../../../../../assets/svg';
import { useStore } from '../../../../../../../../store';
import { AVAILABLE_BILL_MODALS } from '../../../BillsModalsHub/consts';

interface IActionRendererProps {
  billId: string;
  disabled?: boolean;
}
export const ActionRenderer = ({ billId, disabled }: IActionRendererProps) => {
  const setBillActionsReferenceElement = useStore(state => state.setBillActionsReferenceElement);
  const setShowBillDetailsModal = useStore(state => state.setShowBillDetailsModal);
  const setActiveBillModal = useStore(state => state.setActiveBillModal);
  const setSelectedBill = useStore(state => state.setSelectedBill);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    if (!disabled) {
      setShowBillDetailsModal(false);
      setActiveBillModal(AVAILABLE_BILL_MODALS.ACTIONS_MENU);
      setBillActionsReferenceElement(event.currentTarget);
      setSelectedBill(billId);
    }
  };
  return (
    <div data-testid='BillsHub__table-column-three-dots'>
      <Icon
        onClick={handleClick}
        src={threeDotsIcon}
        className={`flex justify-center rounded-full ${!disabled && 'hover:bg-bw03'}`}
      />
    </div>
  );
};
